import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

export default class extends Controller {
    static values = {
        path: String,
    }

    connect() {
        this.updateSlide()
    }

    updateSlide = async () => {
        await get(`${this.pathValue}`);
        setTimeout(() => {
            this.updateSlide()
        }, 5000);
    }
}
